import React, { useEffect, useState } from 'react';

import { Link } from 'react-router-dom';
import Breadcrumb from '../../components/breadcrumb/Breadcrumb';
import { Helmet } from 'react-helmet';
import axios from 'axios';

const Blog = () => {


    const [data, setData] = useState([]);
    const getBlog = async () => {
        const response = await axios.get("https://dev.shivcomputers.in/api/v1/blog");

        console.log("data", response.data);


        setData(response.data);

    }
    useEffect(() => {
        getBlog();
    }, []);

    const truncateText = (text, wordLimit) => {
        const words = text.split(' ');
        if (words.length > wordLimit) {
            return words.slice(0, wordLimit).join(' ') + '...';
        }
        return text;
    };

    return (
        <>
            <Helmet>

                <title>Blog || Shiv computers</title>
                
            </Helmet>
            <Breadcrumb title="Blog" />
            <div className="container">
                <div className="row">
                    {data.map((item) => (
                        <div className="col-md-4 py-4" key={item.id}>
                            <div className="card" style={{ minHeight: '100%' }}>
                                <img

                                    src={item.img}
                                    className="card-img-top img-fluid"
                                    alt={item.title}
                                    loading='lazy'
                                    minHeight="200px"
                                />
                                <div className="card-body">
                                    <h2 className="card-title ">{item.title}</h2>
                                    <div className="d-flex justify-content-between">
                                        <p><i className="bi bi-clock"></i> <span className="text-muted"> {item.time}</span></p>
                                        {/* <p><i className="bi bi-people"></i> <span className="text-muted"> {item.author}</span></p> */}
                                    </div>
                                    <p className="card-text">{truncateText(item.detail, 25)}</p>
                                </div>
                                <div className="py-2">
                                    <Link
                                        to="/blogDetail"
                                        onClick={() => window.scrollTo(0, 0)}
                                        state={item}
                                        className="btn btn-primary"
                                    >Read More</Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default Blog;
